import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { initSentry } from './config/sentry';
import './index.css';

initSentry();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
